module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("ALSO BY SCOTTY MCLENNAN")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Finding Your Religion: When the Faith You Grew Up with Has Lost Its Meaning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Church on Sunday, Work on Monday: The Challenge of Fusing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Christian Values with Business Life")]), _vm._v(", coauthored with Laura Nash")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d9e3671","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780230240582_02_alsoby.vue
// module id = 60
// module chunks = 0